import { VisitorDataFiltersType } from './utilities/types';

export const OFF_VARIATION_KEY = 'off';
export const WAREHOUSE_AUDIENCE_KEY = 'warehouseAudiences';
export const CACHE_CLEANUP_TIMEOUT = 10;
export const CACHE_ITEM_LIFETIME = 5;
export const IN_HOLDOUT_VARIATION_KEY = 'in-holdout';

/**
 * @readonly
 * @enum {string} an Enum of all the possible Kameleoon SDK types
 * */
export enum SdkLanguageType {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  JAVA = 'JAVA',
  CSHARP = 'CSHARP',
  NODEJS = 'NODEJS',
  PHP = 'PHP',
  RUBY = 'RUBY',
  GO = 'GO',
  FLUTTER = 'FLUTTER',
  REACT = 'REACT',
  PYTHON = 'PYTHON',
  JAVASCRIPT = 'JAVASCRIPT',
  RUST = 'RUST',
}

export const DEFAULT_VISITOR_DATA_FILTERS: VisitorDataFiltersType = {
  previousVisitAmount: 1,
  currentVisit: true,
  customData: true,
  pageViews: false,
  geolocation: false,
  device: false,
  browser: false,
  operatingSystem: false,
  conversions: false,
  experiments: false,
  kcs: false,
  visitorCode: true,
  personalization: false,
};
